const dateParse = (dateString) => {
  return new Date(Date.parse(dateString));
};

function formatDate(inputDate) {
  // Convert input string to a Date object
  const date = new Date(inputDate);

  // Extract year, month, and day
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const day = date.getDate().toString().padStart(2, "0");

  // Create the formatted date string
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

function calculateEndDateFromWeeks(startDate, weekDifference) {
  // Convert input strings to Date objects
  startDate = new Date(startDate);

  // Calculate the end date by adding the week difference (7 days per week)
  const endDate = new Date(
    startDate.getTime() + weekDifference * 7 * 24 * 60 * 60 * 1000
  );

  return endDate;
}

function countMondays(startDate, endDate) {
  startDate = new Date(startDate);
  endDate = new Date(endDate);

  let mondayCount = 0;

  while (startDate <= endDate) {
    if (startDate.getDay() === 1) {
      mondayCount++;
    }

    startDate.setDate(startDate.getDate() + 1);
  }

  return mondayCount;
}

function getWeekDifference(startDate, endDate) {
  startDate = new Date(startDate);
  endDate = new Date(endDate);

  // Calculate the difference in milliseconds
  const timeDifference = endDate - startDate;

  // Calculate the number of weeks
  const weeksDifference = Math.floor(
    timeDifference / (1000 * 60 * 60 * 24 * 7)
  );

  return weeksDifference;
}

export {
  dateParse,
  formatDate,
  calculateEndDateFromWeeks,
  countMondays,
  getWeekDifference,
};
